"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Rain(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 2a7.493 7.493 0 0 0-6.648 4.035A5.997 5.997 0 0 0 5 17.91v-2.053C3.279 15.41 2 13.86 2 12a3.987 3.987 0 0 1 3.564-3.975L6.63 7.91l.494-.95A5.49 5.49 0 0 1 12 4a5.508 5.508 0 0 1 5.393 4.424l.296 1.498 1.524.11C20.776 10.141 22 11.446 22 13c0 1.654-1.346 3-3 3v2a5 5 0 0 0 5-5c0-2.64-2.052-4.78-4.645-4.965A7.5 7.5 0 0 0 12 2zM7 15v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-2 0zm8 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-2 0zm-4-3v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-2 0z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Rain;
